import { FC, useMemo } from 'react';

import { Formik, type FormikHelpers } from 'formik';
// import { LoginNominationVerifyForm } from 'pages/public/forms';
import {
  LOGIN_VERIFICATION_FORM,
  LOGIN_VERIFICATION_SCHEMA,
} from 'pages/public/forms/schema';
import LoginNominationVerifyForm from 'pages/public/forms/LoginNominationVerifyForm';
import { MailIcon, SMSIcon } from 'ui/components/icon';
import { MFA_METHOD } from 'utils/constants';
import { MFA } from 'utils/types';
import {
  useLoginNominate,
  useLoginNominateVerifyOtp,
} from 'pages/public/hooks';

import { useLoginContext } from '../Login';

const FORM_INIT = { otp: '' };

interface METHOD_PROPS {
  mfa: MFA;
  method: MFA_METHOD;
}

const Method: FC<METHOD_PROPS> = ({ mfa, method }) => {
  const receiver = useMemo(() => {
    if (method === MFA_METHOD.EMAIL) {
      const { pref, suff, client } = mfa.emailAddress!;

      return `${pref}***${suff}@${client}`;
    }

    if (method === MFA_METHOD.SMS) {
      const { pref, suff } = mfa.recoveryMobileNumber!;

      return `${pref}***${suff}`;
    }

    return null;
  }, [mfa, method]);

  const action = useMemo(() => {
    if (method === MFA_METHOD.EMAIL) return 'emailed';
    if (method === MFA_METHOD.SMS) return 'texted';

    return null;
  }, [method]);

  return (
    <div className="space-y-8">
      <div className="mt-[65px]">
        {method === MFA_METHOD.EMAIL && (
          <MailIcon className="w-[75px] h-[75px] text-primary-base" />
        )}
        {method === MFA_METHOD.SMS && (
          <SMSIcon className="w-[82.5px] h-[75px] text-primary-base" />
        )}
      </div>
      <div className="space-y-4">
        <h3 className="text-secondary-base text-[22px] font-semibold">
          We just {action} you
        </h3>
        <div>
          <p className="text-sm font-normal">
            Please enter the code we {action} you at
          </p>
          <p className="text-sm font-bold">{receiver}</p>
        </div>
      </div>
      <p className="text-sm">Confirmation code</p>
    </div>
  );
};

const LoginNominationVerify: FC = () => {
  const { mfa, method } = useLoginContext();

  const { isLoading, mutate: loginNominate } = useLoginNominate();
  const {
    isLoading: isVerifyOtpLoading,
    mutate: verifyOtp,
    error,
    reset,
  } = useLoginNominateVerifyOtp();

  const handleSubmit = (
    value: LOGIN_VERIFICATION_FORM,
    { setSubmitting }: FormikHelpers<LOGIN_VERIFICATION_FORM>,
  ) => {
    verifyOtp(value);

    setSubmitting(false);
  };

  const handleResetOtp = () => {
    loginNominate({ method: method ?? MFA_METHOD.EMAIL });
  };

  return (
    <>
      <Method mfa={mfa!} method={method!} />
      <Formik
        initialValues={FORM_INIT}
        onSubmit={handleSubmit}
        validationSchema={LOGIN_VERIFICATION_SCHEMA}
      >
        {({ resetForm, isSubmitting, handleChange }) => (
          <LoginNominationVerifyForm
            error={!!error}
            disabled={isSubmitting || isLoading || isVerifyOtpLoading}
            onChange={(e) => {
              handleChange(e);
              // setError(null);
              reset();
            }}
            onResendOtp={() => {
              resetForm();
              handleResetOtp();
            }}
          />
        )}
      </Formik>
    </>
  );
};

export default LoginNominationVerify;
